import React, { useEffect, useState } from 'react';

const EmailConfirmationForm = ({
    handleSendCode,
    confirmationCode,
    setConfirmationCode,
    sendCodeButtonText,
    error,
    sendCodeData,
    onFirstCodeSent,
}) => {
    const [cooldown, setCooldown] = useState(0);
    const [sentOnce, setSentOnce] = useState(false);

    useEffect(() => {
        if (cooldown > 0) {
            const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [cooldown]);

    const onCodeSent = (data) => {
        setCooldown(data.nextSendCooldown);
        setSentOnce(true);
        if (onFirstCodeSent) {
            onFirstCodeSent();
        }
    };

    return (
        <div className="account-confirmation">
            <div className="account-confirmation__row">
                <input
                    type="text"
                    value={confirmationCode}
                    onChange={(e) => setConfirmationCode(e.target.value)}
                    placeholder="Введите код"
                    className="account-code-input"
                />

                <button
                    onClick={(e) => handleSendCode(e, sendCodeData, onCodeSent, cooldown)}
                    className="account-button--ghost"
                    disabled={cooldown > 0}
                    type="button"
                >
                    {cooldown > 0 ? `Отправить код (${cooldown}с)` : sentOnce ? 'Отправить код' : sendCodeButtonText}
                </button>
            </div>

            {error && <p className="account-error">{error}</p>}
        </div>
    );
};

export default EmailConfirmationForm;
